module.exports = __webpack_public_path__ + "img/20220219_073451.1b89592f.jpg";